export var PACKAGE_SOURCE = "components";
export var PACKAGE_VERSION = "3.0.0 (dfa46e92)";
export var THEME = "open-source-classic";
export var ALWAYS_VISUAL_REFRESH = false;